import { Settings } from "../utils/settings";
import { LiturgyItem } from "./types";

export const getLordsPrayer = (
    said: boolean,
    settings: Settings
): LiturgyItem[] => {
    if (said) {
        if (settings.lordsPrayer === "bcp") {
            return [
                {
                    type: "text",
                    content: `**Our Father, which art in heaven, Hallowed be thy Name, Thy
                        kingdom come, Thy will be done, in earth as it is in heaven.
                        Give us this day our daily bread; And forgive us our
                        trespasses, As we forgive them that trespass against us; And
                        lead us not into temptation, But deliver us from evil. Amen.**`,
                },
            ];
        } else {
            return [
                {
                    type: "text",
                    content: `**Our Father, who art in heaven, hallowed be thy Name. Thy
                        kingdom come. Thy will be done, on earth as it is in heaven.
                        Give us this day our daily bread. And forgive us our
                        trespasses, as we forgive those who trespass against us. And
                        lead us not into temptation, but deliver us from evil. For
                        thine is the kingdom, the power, and the glory, for ever and
                        ever. Amen.**`,
                },
            ];
        }
    } else {
        if (settings.lordsPrayer === "bcp") {
            return [
                {
                    type: "chant",
                    boldMode: "all",
                    tone: "2.1",
                    pointedText: {
                        clef: "f5",
                        verses: [
                            {
                                firstHalf: [
                                    {
                                        syllables: [
                                            {
                                                text: "Our",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Fa",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ther,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "which",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "art",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "in",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "hea",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ven,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Hal",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "lowed",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "be",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "thy",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Name,",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Thy",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "king",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "dom",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "come,",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Thy",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "will",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "be",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "done,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "in",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "earth",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "as",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "it",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "is",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "in",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "hea",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ven.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Give",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "this",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "day",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "our",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "dai",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ly",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "bread;",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "And",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "for",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "give",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "our",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "tres",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "pass",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "es,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "as",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "we",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "for",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "give",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "them",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "that",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "tres",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "pass",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "a",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "gainst",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us;",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "And",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "lead",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "not",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "in",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "to",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "temp",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ta",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "tion,",
                                                notes: ["3"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "but",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "de",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "li",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ver",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "from",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "e",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "vil.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                ],
                                secondHalf: [
                                    {
                                        syllables: [
                                            {
                                                text: "A",
                                                notes: ["3"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "men.",
                                                notes: ["4"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                },
            ];
        } else {
            return [
                {
                    type: "chant",
                    boldMode: "all",
                    tone: "2.1",
                    pointedText: {
                        clef: "f5",
                        verses: [
                            {
                                firstHalf: [
                                    {
                                        syllables: [
                                            {
                                                text: "Our",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Fa",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ther,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "who",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "art",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "in",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "hea",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ven,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "hal",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "lowed",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "be",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "thy",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Name.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Thy",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "king",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "dom",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "come.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Thy",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "will",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "be",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "done,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "on",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "earth",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "as",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "it",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "is",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "in",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "hea",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ven.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "Give",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "this",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "day",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "our",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "dai",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ly",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "bread.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "And",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "for",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "give",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "our",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "tres",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "pass",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "es,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "as",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "we",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "for",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "give",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "those",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "who",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "tres",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "pass",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "a",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "gainst",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "And",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "lead",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "not",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "in",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "to",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "temp",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ta",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "tion,",
                                                notes: ["3"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "but",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "de",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "li",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ver",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "us",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "from",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "e",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "vil.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "For",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "thine",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "is",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "the",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "king",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "dom,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "the",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "pow",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "er,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "and",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "the",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "glo",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "ry,",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "for",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "ev",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "er",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "and",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                    {
                                        syllables: [
                                            {
                                                text: "ev",
                                                notes: ["5"],
                                                long: false,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "er.",
                                                notes: ["5"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                ],
                                secondHalf: [
                                    {
                                        syllables: [
                                            {
                                                text: "A",
                                                notes: ["3"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                            {
                                                text: "men.",
                                                notes: ["4"],
                                                long: true,
                                                dotBefore: false,
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                },
            ];
        }
    }
};
